const BACKEND = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

/**
 * Resolves a stored image URL to the current backend URL.
 * Handles:
 *   - Old absolute URLs from a previous preview domain (replaces domain)
 *   - New relative paths starting with /api/ (prepends current BACKEND)
 *   - Already-correct URLs (returned as-is)
 */
export function resolveImgUrl(url) {
  if (!url) return url;
  // Already using the current backend — no change needed
  if (BACKEND && url.startsWith(BACKEND)) return url;
  // URL contains /api/files/ anywhere (old absolute URL from different domain)
  const idx = url.indexOf('/api/files/');
  if (idx !== -1) return BACKEND + url.substring(idx);
  // Relative /api/ path
  if (url.startsWith('/api/')) return BACKEND + url;
  // External or data: URL — return as-is
  return url;
}
